import { createRouter, createWebHistory } from 'vue-router'

// 1. 定义路由映射：哪个路径，展示哪个组件
// 这里使用了路由懒加载，让代码按需加载，优化性能 [citation:6]
const routes = [

    {
        path: '/',
        name: 'Index',
        component: () => import('@/views/Index.vue')
    },

    {
        path: '/adminQr',
        name: 'AdminQr',
        component: () => import('@/views/AdminQr.vue')
    },
]

// 2. 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router